module.exports = __webpack_public_path__ + "img/l3.f46b7ef8.png";